import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setInsuranceCompany } from 'redux/actions';
import { logoHeaderImage } from 'images/landingpages/dak';
import { TEXT } from '../locales/landingpages/dakBgm';
import { getZppCourseOfferId } from '../utils/getZppCourseOfferId';

export const useDakBgmContent = (isDak = true) => {
  const dispatch = useDispatch();
  const { headerText, checkmarkText, ballooniText } = TEXT;

  useEffect(() => {
    dispatch(
      setInsuranceCompany({
        insuranceCompany: {
          id: `INSURANCE_COMPANY_DAK${isDak ? '' : '_BGM'}`,
          name: 'DAK-Gesundheit',
          supportEmail: 'dak@balloonapp.de',
          cooperationLogo: logoHeaderImage,
          cooperationLogoHover: logoHeaderImage,
          cooperationPartner: true,
          slug: `dak-${isDak ? 'bgm' : 'other'}`,
          zppCourseOffers: [
            {
              id: 'BE-COURSE-ID',
              courseTitle: 'DAK Antistress-Coaching (achtsamkeitsbasiert)',
              slug: 'sda',
              offerId: getZppCourseOfferId('dakBgm'),
              content: {
                headerHeadline: headerText.headline,
                headerSubline: headerText.subline,
                formFieldsAvailable: isDak
                  ? ['company_name', 'postal_code', 'insurance_number', 'gender', 'age', 'postal_code_check']
                  : ['company_name', 'postal_code', 'gender', 'age', 'postal_code_check'],
                additionalConsentChecks: ['postal_code_check'],
                formFieldsRequired: ['company_name_required', 'postal_code_required'],
                courseinfoHeadline: checkmarkText.headline,
                courseinfoDescription: [checkmarkText.subline_1, checkmarkText.subline_2].join('\n'),
                courseinfoChecklist: [checkmarkText.checkmark_1, checkmarkText.checkmark_2, checkmarkText.checkmark_3].join('\n\n'),
                howtoHeadline: ballooniText.headline,
                howtoText1: ballooniText.ballooni_1,
                howtoText2: ballooniText.ballooni_2,
                howtoText3: ballooniText.ballooni_3,
                headerLogoUrl: logoHeaderImage
              }
            }
          ]
        }
      })
    );
  }, [isDak]);
};
